import api from './api';
import type { InventoryLot, ItemLotsResponse, PaginatedResponse } from '../types/venue';

const base = (venueId: string) => `/admin/venue/${venueId}/inventory/lot`;

export interface GetLotsParams {
  inventoryItemId?: string;
  active?: boolean;
  page?: number;
  pageSize?: number;
}

const inventoryLotService = {
  /** List lots for a venue, optionally filtered by inventoryItemId or active state. */
  getLots: async (
    venueId: string,
    params: GetLotsParams = {},
  ): Promise<PaginatedResponse<InventoryLot>> => {
    const response = await api.get(base(venueId), { params });
    return response.data;
  },

  /** Get a single lot by ID. */
  getLotById: async (venueId: string, lotId: string): Promise<InventoryLot> => {
    const response = await api.get(`${base(venueId)}/${lotId}`);
    return response.data;
  },

  /**
   * Get all lots for a specific inventory item, enriched with per-location quantities.
   * Returns ItemLotsResponse: { itemId, lotTracked, lots: [...] }
   */
  getItemLots: async (venueId: string, itemId: string): Promise<ItemLotsResponse> => {
    const response = await api.get(`/admin/venue/${venueId}/inventory/item/${itemId}/lot`);
    return response.data;
  },
};

export default inventoryLotService;
